import React from 'react';
import { bool, array } from 'prop-types';
import styled from 'styled-components';
import { format } from 'date-fns';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${props => (props.onMobile ? '10px 0px' : '10px 16px')};
  gap: 4px;
  background: ${({ theme }) => theme.colors.primaryWhite};
  border-radius: 4px;
  /* Inside auto layout */
  flex: none;
  order: 2;
  flex-grow: 0;
  margin-top: 26px;
  ${props => props.onMobile && 'border-top: 1px solid #D9DBE0;'}
`;

const Header = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 14px;
  font-weight: 500;
  line-height: ${props => (props.onMobile ? '21px' : '18px')};
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme, onMobile }) =>
    onMobile ? theme.colors.darkBlack : theme.colors.greyDark};
`;

const Text = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${props => (props.onMobile ? '14px' : '12px')};
  font-weight: 400;
  line-height: ${props => (props.onMobile ? '24px' : '18px')};
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme, onMobile }) =>
    onMobile ? theme.colors.darkBlack : theme.colors.greyDark};
`;

export const CancellationPolicy = ({
  onMobile,
  cancelPenalties,
  enabled,
  isTranslate,
}) => {
  const [dateEnd = '', time1 = ''] = cancelPenalties?.[0].endDate || [];

  // Handling invalid or missing penalty timeEnd

  const time2 = extractTime(cancelPenalties?.[0].end || '23:59');
  const time = time1.trim() === '' ? time2 : time1;

  const cancelDate =
    new Date(dateEnd).toString() !== 'Invalid Date'
      ? format(new Date(dateEnd), `MMMM dd, yyyy`)
      : '';

  return (
    enabled &&
    cancelPenalties && (
      <Container onMobile={onMobile}>
        <Header onMobile={onMobile}>
          {isTranslate
            ? translate(`snapCancellation.guestDetails.header`)
            : 'Hotel cancelation policy'}
        </Header>
        <Text onMobile={onMobile}>
          {isTranslate
            ? translate(`snapCancellation.guestDetails.content`, {
                cancellation_time: time,
                cancellation_date: cancelDate,
              })
            : 'Free cancellation before ' +
              time +
              ' hrs on ' +
              cancelDate +
              ' (property local time). Any cancellation later than the date, no refund will be given.'}
        </Text>
      </Container>
    )
  );
};

const extractTime = dateString => {
  const hasTimeComponent = dateString.indexOf(':') >= 0;
  const dateObject = new Date(
    hasTimeComponent ? dateString : `${dateString}T23:59`
  );
  const hours = dateObject.getHours();
  const minutes = dateObject
    .getMinutes()
    .toString()
    .padStart(2, '0');
  if (isNaN(hours) || isNaN(minutes)) {
    return '23:59';
  }

  const time = hours + ':' + minutes;
  return time;
};

CancellationPolicy.propTypes = {
  onMobile: bool,
  enabled: bool,
  cancelPenalties: array,
  isTranslate: bool,
};

CancellationPolicy.defaultProps = {
  onMobile: false,
  enabled: true,
  cancelPenalties: [],
  isTranslate: true,
};
